<script setup lang="ts">
import {
  GoalPosition,
  PitchDistance,
  PitchPosition,
} from '@collector/mobile-feature-goal-and-pitch-positions'
import Button from '@mobile/components/Button/Button.vue'
import IncidentBasicInfo from '@mobile/views/Relation/DetailsPanel/Modals/IncidentDetailsModal/IncidentBasicInfo.vue'
import Modal from '@mobile/views/Relation/DetailsPanel/Modals/Modal.vue'
import ModalButtons from '@mobile/views/Relation/DetailsPanel/Modals/ModalButtons.vue'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'

import ThrowPositionIndicatorGroup from './ThrowPositionIndicator/ThrowPositionIndicatorGroup.vue'

interface Props {
  linkedIncident: ProbableLinkedIncident
  pitchPositionName: string
  goalPositionDisabled?: boolean
  pitchPositionDisabled?: boolean
  isThrowPositionFulfilled?: boolean
}
defineProps<Props>()

// model
const goalPosition = defineModel<GoalPosition>('goalPosition', {
  default: null,
})
const pitchDistance = defineModel<PitchDistance>('pitchDistance', {
  default: null,
})
const pitchPosition = defineModel<PitchPosition>('pitchPosition', {
  default: null,
})

// emits
defineEmits<{
  close: []
  save: []
}>()
</script>

<template>
  <Modal id="incidentDetailsModal">
    <IncidentBasicInfo :linkedIncident />

    <slot name="prePitchComponent" />

    <ThrowPositionIndicatorGroup
      v-model:goalPosition="goalPosition"
      v-model:pitchDistance="pitchDistance"
      v-model:pitchPosition="pitchPosition"
      :name="pitchPositionName"
      :goalPositionDisabled
      :pitchPositionDisabled
      :isFulfilled="isThrowPositionFulfilled"
    />

    <div class="pt-4">
      <slot />
    </div>

    <ModalButtons>
      <Button
        color="red"
        :size="'lg'"
        @click="$emit('close')"
      >
        Close
      </Button>
      <Button
        class="px-8"
        color="green"
        :size="'lg'"
        @click="$emit('save')"
      >
        Save
      </Button>
    </ModalButtons>
  </Modal>
</template>
